export default "__VITE_ASSET__D8LMCx6p__"